import React, { Fragment, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import "./index.scss";
import Cookies from "universal-cookie";
import { ToastContainer, toast } from "react-toastify";
import { setAuthInfo } from "../../module/auth/auth.action";
import { CONFIG } from "../../config/constant";
import Header from "../../component/Header";
import { useDispatch, useSelector } from "react-redux";
import profileImage from "../../assets/images/profile-default.svg";
import editImage from "../../assets/images/edit.svg";
import { translation } from '../../i18';


const Profile = (props) => {
  const { t } = translation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const cookies = new Cookies();
  const [profile, setProfile] = useState(null);
  const [editProfile, setEditProfile] = useState({});
  const [showPopup, setShowPopup] = useState(false);
  const [editPopup, setEditPopup] = useState(false);


  const [transactions, setTransactions] = useState([]);
  const { token } = useSelector((state) => state.auth);
  useEffect(() => {
    getProfile();
    getTransactions()
  }, []);

  function formatISOToGMTAmPm(isoDateStr) {
    const date = new Date(isoDateStr);
    let time = date.getTimezoneOffset();
    time = date.getTime() - (time * 60 * 1000);
    date.setTime(time);
    const options = {
      timeZone: 'GMT',
      year: 'numeric',
      month: 'long',
      day: 'numeric',
      hour: 'numeric',
      minute: '2-digit',
      hour12: true,
      // timeZoneName: 'short'
    };

    return date.toLocaleString('en-US', options);
  }
  async function getProfile() {
    const url = CONFIG.BASE_URL + `app/account`;
    let response = await fetch(url, {
      method: "GET",
      mode: "cors",
      cache: "no-cache",
      headers: {
        "Content-Type": "application/json",
        "Authorization": token
      },
    });
    if (response && response.status === 200) {
      response = await response.json();
      setProfile(response);
      setEditProfile(response);
    } else {
      response = await response.json();
    }
  }

  const logout = (e) => {
    cookies.remove("email");
    cookies.remove("token");
    cookies.remove("role");
    cookies.remove("userid");
    cookies.remove("isLogin");
    dispatch(setAuthInfo({
      email: "",
      token: "",
      role: "",
      userid: "",
      isLogin: false,
    }));
    navigate("/login");
  }

  const getTransactions = async () => {
    const url = CONFIG.BASE_URL + `app/transactions`;
    let response = await fetch(url, {
      method: "GET",
      mode: "cors",
      cache: "no-cache",
      headers: {
        "Content-Type": "application/json",
        "Authorization": token
      },
    });
    if (response && response.status === 200) {
      response = await response.json();
      setTransactions(response);
    } else {
      response = await response.json();
    }
  };

  async function editPackage() {
    const url = CONFIG.BASE_URL + `app/account`;
    let response = await fetch(url, {
      method: "POST",
      mode: "cors",
      cache: "no-cache",
      headers: {
        "Content-Type": "application/json",
        Authorization: token,
      },
      body: JSON.stringify({
        email: editProfile.email,
        firstname: editProfile.firstname,
        lastname: editProfile.lastname
      }),
    });
    setEditPopup(false);
    if (response.status === 200) {
      response = await response.json();
      toast(response.message || response.error_message);
      getProfile();
    } else {
      response = await response.json();
      toast(response.message || response.error_message);
    }
  }

  return (
    <Fragment>
      <div className="setting-page">
        <Header />
        <div className="page-content">
          <div className="title">{t('profile')}</div>
          <div className="content-wrapper">
            <div className="image-wrapper">
              <img src={profileImage} />
              <img className="edit-image" src={editImage} onClick={(e) => { setEditPopup(true); }} />
            </div>
            <div className="text-wrapper">
              <span className="key">{t('name')} :</span>
              <span className="value">{profile?.firstname} {profile?.lastname}</span>
            </div>
            <div className="text-wrapper">
              <span className="key">{t('email')} :</span>
              <span className="value">{profile?.email}</span>
            </div>
            <input className="logout-btn" type="button" onClick={() => { logout() }} value={t('logout')} />
            <input className="logout-btn" type="button" onClick={() => { setShowPopup(true) }} value={t('transactions')} />
          </div>
        </div>

        {showPopup ? <div className="popup-container">
          <div className="popup-wrapper">
            <div className="popup-header">
              <span className="title">{t('transactionHistory')}</span>
              <span className="close-btn" onClick={(e) => setShowPopup(false)}></span>
            </div>
            <div className="popup-content">
              <div className="list">

                <div className="list-header">
                  <span className="title">{t('title')}</span>
                  <span className="amount">{t('price')}</span>
                  <span className="expiry">{t('rentedOn')}</span>
                </div>
                {transactions?.map((item) => {
                  return (<div className="list-item">
                    <span className="title">{item?.content?.title['en']}</span>
                    <span className="amount">${item?.amount}</span>
                    <span className="expiry">{formatISOToGMTAmPm(item?.purchaseDate)}</span>
                  </div>)
                })}

              </div>
            </div>
          </div>
        </div> : null}

        {editPopup ? <div className="popup-container">
          <div className="popup-wrapper medium">
            <div className="popup-header">
              <span className="title">Edit Profile</span>
              <span className="close-btn" onClick={(e) => setEditPopup(false)}></span>
            </div>
            <div className="popup-content medium">
              <div className="text-wrapper">
                <label className="label">First Name</label>
                <input
                  type="text"
                  className="text-input"
                  placeholder='First Name'
                  onChange={(e) =>
                    setEditProfile({ ...editProfile, firstname: e.target.value })
                  }
                  value={editProfile?.firstname}
                />
              </div>
              <div className="text-wrapper">
                <label className="label">Last Name</label>
                <input
                  type="text"
                  className="text-input"
                  placeholder='Last Name'
                  onChange={(e) =>
                    setEditProfile({ ...editProfile, lastname: e.target.value })
                  }
                  value={editProfile?.lastname}
                />
              </div>
              <div className="text-wrapper">
                <label className="label">Email</label>
                <input
                  type="text"
                  className="text-input"
                  placeholder="User Email"
                  onChange={(e) =>
                    setEditProfile({ ...editProfile, email: e.target.value })
                  }
                  value={editProfile.email}
                />
              </div>
              <input type="button" className="edit-btn" value="Update" onClick={editPackage} />
            </div>
          </div>
        </div> : null}

      </div>
      <ToastContainer />
    </Fragment>
  );
};

export default Profile;
